module.exports = __webpack_public_path__ + "img/img_default_search@2x.0bcff4e5.png";